/**
 * @generated SignedSource<<c5f729119b6ba137c9add7ec80f43a6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditAnnouncementMessage_chat_messageFragment$data = {
  readonly conversation: {
    readonly id: string;
    readonly participants: ReadonlyArray<string>;
    readonly reference: {
      readonly internal_id: string;
    };
  };
  readonly deletedAt: ISO8601DateTimeString | null;
  readonly id: string;
  readonly isEdited: boolean;
  readonly text: UnknownJSON;
  readonly updatedAt: ISO8601DateTimeString;
  readonly " $fragmentType": "EditAnnouncementMessage_chat_messageFragment";
};
export type EditAnnouncementMessage_chat_messageFragment$key = {
  readonly " $data"?: EditAnnouncementMessage_chat_messageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditAnnouncementMessage_chat_messageFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditAnnouncementMessage_chat_messageFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deletedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEdited",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Conversation",
      "kind": "LinkedField",
      "name": "conversation",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "participants",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Reference",
          "kind": "LinkedField",
          "name": "reference",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "internal_id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Message",
  "abstractKey": null
};
})();

(node as any).hash = "506485aa97108e7c51079d8d0846c5cc";

export default node;
